export default {
	'invoice-category': 'invoice category',
	'add-invoice-category': 'add invoice category',
	'use-category-for': 'Use category for',
	'set-a-default-for': 'set as default for',

	'default-sales-category': 'default sales category',
	'default-purchases-category': 'default purchases category',
	'default-sales-refund-category': 'default sales refund category',
	'default-purchases-refund-category': 'default purchases refund category',

	'default-invoices-categories': 'Default categories'
}